import React, { useState,useEffect } from "react";
import { API_URL,RESPONSE_SUCCESS } from '../../GlobalConstents.js';
import { Link, useNavigate,useParams } from "react-router-dom";
import API from '../../Api.js';
import { toast } from 'react-toastify';

import {RouteChanged,ROUTE_EXAM_SINGLE_REPORT } from '../../RouteConstents';
import HeaderLayout from "./../../Layout/Header";


const ExamReport = () => {
    
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
   
    const [examTitle, setExamTitle] = useState('');
    const [totalQuestion, setTotalQuestion] = useState('');
    const [totalTime, setTotalTime] = useState('');
    const [AttemptedInfo, setAttemptedInfo] = useState('');
    const [totalMarks, setTotalMarks] = useState('');
    
    const { string } = useParams();

    useEffect(
        () => {
        document.body.classList.add('theme-red');
        document.body.classList.remove('login-page');
        document.body.classList.remove('overlay-open');
        LoadExamReport()
    },[]); 

    const LoadExamReport = async () => {

        let objValue =  {"method_name":"examReport","test_id":string}

        setIsLoading(true);
        await API.post(API_URL,objValue).then(function (response) {
            setIsLoading(false);
            if (response.status === RESPONSE_SUCCESS) {
                if (response.data.status === "success") {
                      
                    setExamTitle(response.data.reportInfo.examtitle)   
                    setTotalQuestion(response.data.reportInfo.totalQuestion)   
                    setTotalTime(response.data.reportInfo.timeTaken);   
                    setAttemptedInfo(response.data.reportInfo.AttemptedInfo)
                    setTotalMarks(response.data.reportInfo.totalMarks) 
                
                } else {
                    toast.error(response.data.message);
                }
            }

        }).catch(function (error) {
           // ForceLogoutUser(error);
        });

    }

    const goToSingleExamReport = async (examString) => {
        let newURL = RouteChanged(ROUTE_EXAM_SINGLE_REPORT,examString)
        navigate(newURL);
    } 

    
    let pageTitle = 'Knowledge Section'
    
    return (
        <>
        <HeaderLayout pageTitle={pageTitle} />
        
        <section className="content">
            <div className="container-fluid">
                <div className="block-header">
                    <h2>Exam Report</h2>
                </div>            
                <div className="row clearfix">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="card">
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover "  >
                                    <tbody>
                                        <tr>
                                            <td width="49%">Exam Name</td>
                                            <td>{examTitle}</td>
                                        </tr>
                                        <tr>
                                            <td>Total Questions</td>
                                            <td>{totalQuestion}</td>
                                        </tr>
                                        <tr>
                                            <td>Total Time</td>
                                            <td>{totalTime}</td>
                                        </tr>
                                        <tr>
                                            <td>Total Marks</td>
                                            <td>{totalMarks}</td>
                                        </tr>
                                       
                                    </tbody>
                                </table>
                            </div>
                            <ul className="list-group">
                                {
                                    AttemptedInfo && AttemptedInfo.map((item) => {
                                        
                                        let optionClass = 'badge bg-pink'; 
                                        let resultType = 'Fail'; 
                                        if(item.showResult === 1) {
                                            optionClass = 'badge bg-green';
                                            resultType = 'Pass';  
                                        }

                                        return (
                                            <>
                                                <li className="list-group-item" onClick={() => {goToSingleExamReport(item.test_repord_id)}}><b>Attempt {item.attempt_no}</b> [ {item.attempt_date} ]  <span className={optionClass} >{resultType}</span></li>
                                            </>
                                        )
                                    })
                                }                     



                               
                            </ul>
                            
                        </div>                           
                    </div>
                </div>
            </div>
        </section>
        
        </>
    );
   
}
    
export default ExamReport;